module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "title": _vm.title,
      "icon": 'fa fa-' + _vm.getIcon(this.category),
      "title-heading": "h2",
      "table-ref": "orgtable",
      "url": '/org' + (this.category ? '?filter=' + this.category : ''),
      "fields": _vm.fields,
      "hide-top": !_vm.showTitle,
      "show-search": _vm.showSearch,
      "sort-field": "name",
      "add-action": _vm.showAdd() ? _vm.addOrg : null,
      "add-props": _vm.addProps,
      "hide-org-badge": "",
      "org-badge-no-full-name": "",
      "detail-component": "org-detail-row"
    },
    scopedSlots: _vm._u([{
      key: "shortName",
      fn: function(props) {
        return [_c('org-badge', {
          attrs: {
            "organisation": props.rowData
          }
        })]
      }
    }, {
      key: "subCat",
      fn: function(props) {
        return [_c('i', [_vm._v(_vm._s(_vm.ellipsis(props.rowData.subCategory)))])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1235983b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/OrgTable.vue
// module id = 1430
// module chunks = 0